import { Toaster as Sonner, ToasterProps } from "sonner";
import { useTheme } from "@/context/theme-provider";
import { useIsMobile } from "@/hooks/use-mobile";

export function Toaster({ ...props }: ToasterProps) {
  const { theme = "system" } = useTheme();
  const isMobile = useIsMobile();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position={isMobile ? "top-center" : "bottom-right"}
      closeButton={true}
      offset={16}
      className="toaster group"
      style={{ zIndex: 99999 }}
      toastOptions={{
        classNames: {
          toast: "group toast bg-background text-foreground border border-border shadow-lg rounded-lg p-4 flex items-center gap-3 w-full max-w-sm sm:max-w-md md:max-w-lg transition-all duration-300 ease-in-out",
          description: "text-muted-foreground text-sm leading-5 mt-1",
          actionButton: "bg-primary text-primary-foreground px-3 py-1.5 rounded-md text-sm font-medium transition-colors hover:bg-primary/90 focus:ring-2 focus:ring-primary/20 shrink-0",
          cancelButton: "bg-muted text-muted-foreground px-3 py-1.5 rounded-md text-sm font-medium transition-colors hover:bg-muted/80 focus:ring-2 focus:ring-muted/20 shrink-0",
          closeButton: "text-muted-foreground hover:text-foreground transition-colors absolute right-3 top-3 h-5 w-5 opacity-70 hover:opacity-100 focus:ring-2 focus:ring-primary/20 rounded-sm",
          success: "!bg-green-50 !text-green-800 !border-green-200 dark:!bg-green-950 dark:!text-green-100 dark:!border-green-800/30",
          error: "!bg-red-50 !text-red-800 !border-red-200 dark:!bg-red-950 dark:!text-red-100 dark:!border-red-800/30",
          warning: "!bg-amber-50 !text-amber-800 !border-amber-200 dark:!bg-amber-950 dark:!text-amber-100 dark:!border-amber-800/30",
          info: "!bg-blue-50 !text-blue-800 !border-blue-200 dark:!bg-blue-950 dark:!text-blue-100 dark:!border-blue-800/30",
        },
      }}
      {...props}
    />
  );
}
